export const DELETE_FILE_REFERENCE_FAILURE = 'DELETE_FILE_REFERENCE_FAILURE';

export const deleteFileReferenceFailure = (payload: Error) => ({
    type: DELETE_FILE_REFERENCE_FAILURE,
    payload,
    error: true,
});
